export function getProfilePicture(profile, defaultEmoji) {
    if (profile && profile.picture_url && profile.picture_url.startsWith('emoji://')) {
        return profile.picture_url.replace('emoji://', '');
    }
    return defaultEmoji;
}
